@use 'src/globals/main';

pn-read-only-button {
  display: inline-block;
}

pn-read-only-button button {
  cursor: not-allowed;
  color: main.$input-color-disabled;
  background: main.$input-background-disabled;
  padding: 0.75em 1.2em;
  width: 100%;
  border: none;
  border-radius: 3em;
  outline: none;
  position: relative;
  font-size: 1em;
  min-height: 3em;
  min-width: 5.5em;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-tap-highlight-color: transparent;

  pn-icon {
    flex-shrink: 0;
    margin: 0 0 0 0.5em;
  }

  .button-tooltip {
    position: absolute;
    bottom: calc(100% + 0.35em);
    left: 50%;
    background: main.$warning;
    color: main.$white;
    padding: 0.25em 0.75em;
    font-size: 0.875em;
    font-weight: 300;
    border-radius: 1em;
    box-shadow:
      0 1.2px 3.6px rgba(0, 0, 0, 0.1),
      0 6.4px 14.4px rgba(0, 0, 0, 0.13);
    z-index: 5;
    max-width: min(95vw, 40em);
    transform: translateX(-50%);
    width: max-content;
    pointer-events: none;

    opacity: 0;
    @include main.pn-transition('opacity');
  }

  &[data-tooltip-open] {
    .button-tooltip {
      opacity: 1;
    }
  }
}

/* -----------------LEFT ALIGNED ICON------------------ */
pn-read-only-button button.pn-button-left-icon {
  flex-direction: row-reverse;

  pn-icon {
    margin: 0 0.5em 0 0;
  }
}
/* -----------------/LEFT ALIGNED ICON------------------ */

/* -----------------ICON ONLY------------------ */
pn-read-only-button button.icon-only {
  width: 3em;
  min-width: 0;

  pn-icon {
    margin: 0;
  }

  &.pn-button-small {
    width: 2.286em;
    min-width: 0;
    padding: 0;
  }

  span.read-only-icon-only {
    display: none;
  }
}
/* -----------------/ICON ONLY------------------ */

/* -----------------SMALL------------------ */
pn-read-only-button button.pn-button-small {
  font-size: 0.875em;
  padding: 0.5em 1em;
  font-weight: normal;
  min-height: 2.286em;
  min-width: none;

  pn-icon .pn-icon-svg {
    height: 1.28em;
    width: 1.28em;
  }
}
/* -----------------/SMALL------------------ */
